import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { openSetReceivedDateModal } from '../../../store/returns/grid/returns.grid.actions';
import Global from '../../../store/global-selectors';

const MarkReceived = () => {
  const dispatch = useDispatch();

  const markReceived = useCallback(() => {
    dispatch(openSetReceivedDateModal());
  }, [dispatch]);

  const selectedReturnsCount = useSelector(Global.selectSelectedReturnsCount);
  return (
    <Button disabled={selectedReturnsCount < 1} onClick={markReceived} theme='tertiary'>
      <FormattedMessage defaultMessage='Mark as Received' description='returnsPageHeader.markReceived' id='mSLupK' />
    </Button>
  );
};

export default MarkReceived;
